import { useState } from 'react'
import { fetchInstitutionDonorNumbers } from '@/lib/institution-donors'
import type { InstitutionDonorLuckyNumber } from '@/types/institution-donor'
import styles from './DonorLuckyNumbersSection.module.css'
export function DonorRouletteNumbers({
  donorId,
  token,
}: {
  donorId: number
  token?: string | null
}) {
  const [numbers, setNumbers] = useState<InstitutionDonorLuckyNumber[]>([])
  const [page, setPage] = useState(0)
  const [lastPage, setLastPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const load = async () => {
    if (loading) return
    setLoading(true)
    setError(false)
    try {
      const result = await fetchInstitutionDonorNumbers(donorId, page + 1, token, true)
      setNumbers((current) => [
        ...new Map([...current, ...result.numbers].map((n) => [n.id, n])).values(),
      ])
      setPage(result.pagination.current_page)
      setLastPage(result.pagination.last_page)
      setTotal(result.pagination.total)
    } catch {
      setError(true)
    } finally {
      setLoading(false)
    }
  }
  return (
    <section aria-label="Números ganhos na roleta">
      <h3>Números ganhos na roleta</h3>
      {page > 0 && (
        <p>
          {total
            ? total + ' números entregues pela roleta, sem custo.'
            : 'Nenhum número ganho na roleta.'}
        </p>
      )}
      {numbers.length > 0 && (
        <ul>
          {numbers.map((n) => (
            <li key={n.id}>
              <strong>{n.number}</strong> ·{' '}
              {n.campaign_title ?? 'Campanha #' + n.campaign_id} · Ganho na roleta
            </li>
          ))}
        </ul>
      )}
      {error && (
        <p role="alert">
          Não foi possível carregar os números da roleta. Tente novamente.
        </p>
      )}
      {(page === 0 || page < lastPage || error) && (
        <button
          type="button"
          className={styles.moreButton}
          disabled={loading}
          onClick={() => void load()}
        >
          {loading
            ? 'Carregando números…'
            : error
              ? 'Tentar novamente'
              : page
                ? 'Ver mais números da roleta'
                : 'Ver números ganhos na roleta'}
        </button>
      )}
    </section>
  )
}
